import React from "react";
import ReceiveStockBody from "../components/presentational/ReceiveStockBody.jsx";

export default function ReceiveStockView({
  roleId,
  activeTab,
  handleTabChange,
  entryMode,
  setEntryMode,
  dispensaryType,
  setDispensaryType,
  itemType,
  setItemType,
  frontShopType,
  setFrontShopType,
  otcType,
  setOtcType,
  otherCategorySelected,
  setOtherCategorySelected,
  categories,
  suppliers,
  errors,
  handleSubmit,
  showSuccess,
  setShowSuccess,
  scanBarcode,
  onScanChange,
  scanDrug,
  scanItem,
  scanReturnOnSave,
}) {
  function getSelectedType() {
    const normalize = (v) => (v === "Drug" ? "drug" : v === "Item" ? "item" : undefined);

    if (activeTab === "Dispensary") return normalize(dispensaryType);
    if (activeTab === "Front Shop") return normalize(frontShopType);
    if (activeTab === "OTC") return normalize(otcType);

    if (activeTab === "Clinic") {
      if (roleId === 6) return "drug"; // clinic-only default
      return normalize(itemType);
    }

    return undefined;
  }

  function handleFormSubmit(payload) {
    const type = getSelectedType();
    return handleSubmit(type ? { ...payload, type } : payload);
  }

  const selectedType = getSelectedType();

  return (
    <ReceiveStockBody
      roleId={roleId}
      activeTab={activeTab}
      handleTabChange={handleTabChange}
      entryMode={entryMode}
      setEntryMode={setEntryMode}
      dispensaryType={dispensaryType}
      setDispensaryType={setDispensaryType}
      itemType={itemType}
      setItemType={setItemType}
      frontShopType={frontShopType}
      setFrontShopType={setFrontShopType}
      otcType={otcType}
      setOtcType={setOtcType}
      otherCategorySelected={otherCategorySelected}
      setOtherCategorySelected={setOtherCategorySelected}
      categories={categories}
      suppliers={suppliers}
      errors={errors}
      handleFormSubmit={handleFormSubmit}
      showSuccess={showSuccess}
      setShowSuccess={setShowSuccess}
      scanBarcode={scanBarcode}
      onScanChange={onScanChange}
      scanDrug={scanDrug}
      scanItem={scanItem}
      selectedType={selectedType}
      scanReturnOnSave={scanReturnOnSave}
    />
  );
}
